import { render, staticRenderFns } from "./addSuppleQualifications.vue?vue&type=template&id=18d0a28b&scoped=true"
import script from "./addSuppleQualifications.vue?vue&type=script&lang=js"
export * from "./addSuppleQualifications.vue?vue&type=script&lang=js"
import style0 from "./addSuppleQualifications.vue?vue&type=style&index=0&id=18d0a28b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0a28b",
  null
  
)

export default component.exports